<section class="panel p-4">
  <h2 class="h5 mb-3">Cadastro de secretarias</h2>
  <form class="row g-3" (ngSubmit)="salvar()">
    <div class="col-md-5">
      <label class="form-label">Empregador</label>
      <select
        class="form-select"
        name="secretariaEmpregador"
        [ngModel]="empregadorSelecionado"
        (ngModelChange)="selecionarEmpregador($event)"
        required>
        <option value="">Selecione</option>
        <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
      </select>
    </div>

    <div class="col-md-4">
      <label class="form-label">Secretaria existente</label>
      <select
        class="form-select"
        name="secretariaExistente"
        [ngModel]="secretariaSelecionada"
        (ngModelChange)="selecionarSecretaria($event)">
        <option value="">Nova secretaria</option>
        <option *ngFor="let item of secretarias" [value]="item.id">{{ item.nome }}{{ item.ativo ? '' : ' (inativa)' }}</option>
      </select>
    </div>

    <div class="col-md-3 d-flex align-items-end">
      <button class="btn btn-outline-primary w-100" type="button" (click)="recarregar()">Atualizar</button>
    </div>

    <div class="col-md-8">
      <label class="form-label">Nome</label>
      <input class="form-control" name="secretariaNome" [(ngModel)]="secretaria.nome" required>
    </div>

    <div class="col-md-4 d-flex align-items-end">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" name="secretariaAtivo" [(ngModel)]="secretaria.ativo">
        <label class="form-check-label">Ativo</label>
      </div>
    </div>

    <div class="col-12">
      <app-rodape-crud
        [exibirExcluir]="true"
        [excluirDesabilitado]="!secretaria.id"
        (excluir)="excluir()"
        (limpar)="limpar()"
        (salvar)="salvar()">
      </app-rodape-crud>
    </div>
  </form>
</section>
